var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop, Model } from "vue-property-decorator";
import ImgLinkValue from './ImgLinkValue';
var ImgLinkInput = (function (_super) {
    __extends(ImgLinkInput, _super);
    function ImgLinkInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImgLinkInput.prototype.beforeAvatarUpload = function (file) {
        var isLtMaxSize = file.size / 1024 / 1024 < this.maxSize;
        if (!isLtMaxSize) {
            this.$message({
                showClose: true,
                message: "单张图片不能超过 " + this.maxSize + "MB!",
                type: 'error'
            });
            return false;
        }
    };
    ImgLinkInput.prototype.uploadSuccess = function (response, file, fileList) {
        if (file && file.response && file.response.data && file.response.data.full_path) {
            var tempFile = JSON.parse(JSON.stringify(this.imageItem));
            tempFile.url = file.response.data.full_path;
            this.$emit("change", tempFile);
        }
    };
    ImgLinkInput.prototype.remove = function () {
        this.$emit('remove', this.imageIndex);
    };
    ImgLinkInput.prototype.changeLinkValue = function (imageItem) {
        this.$emit("change", imageItem);
    };
    __decorate([
        Prop({
            default: "/supplierapi/upload",
            type: String
        })
    ], ImgLinkInput.prototype, "action", void 0);
    __decorate([
        Prop({
            default: 10,
            type: Number
        })
    ], ImgLinkInput.prototype, "maxSize", void 0);
    __decorate([
        Prop({
            default: "",
            type: String
        })
    ], ImgLinkInput.prototype, "typeName", void 0);
    __decorate([
        Prop({
            type: Number
        })
    ], ImgLinkInput.prototype, "imageIndex", void 0);
    __decorate([
        Prop({
            type: Number
        })
    ], ImgLinkInput.prototype, "imageListLength", void 0);
    __decorate([
        Prop({
            default: "750px*260px",
            type: String
        })
    ], ImgLinkInput.prototype, "pixelTip", void 0);
    __decorate([
        Prop({
            default: true,
            type: Boolean
        })
    ], ImgLinkInput.prototype, "isNeedGoods", void 0);
    __decorate([
        Model("change", {
            required: true,
            type: Object
        })
    ], ImgLinkInput.prototype, "imageItem", void 0);
    ImgLinkInput = __decorate([
        Component({
            components: {
                ImgLinkValue: ImgLinkValue
            }
        })
    ], ImgLinkInput);
    return ImgLinkInput;
}(Vue));
export default ImgLinkInput;
